<div class="fixed bottom-0 top-0 w-full sm:w-[36rem] lg:sticky lg:left-full lg:h-screen lg:w-16 lg:shadow">
    <div class="bg-card flex h-full w-full flex-col transition-transform duration-400 ease-drawer sm:w-[36rem]"
         [ngClass]="{
            '-translate-x-full shadow sm:-translate-x-[36rem] lg:-translate-x-[32rem]': opened,
            'translate-x-0': !opened
         }">

        <!-- HEADER-->
        <div class="quick-chat-header flex flex-0 cursor-pointer items-center justify-start">
            @if (!opened || (opened && !selectedChat)) {
                <div class="flex flex-auto items-center">
                    <div class="relative flex w-16 flex-0 items-center justify-center" (click)="toggle()">
                        <mat-icon class="icon-size-6" [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
                        @if (totalUnreadCount > 0) {
                            <span class="quick-chat-main-badge absolute right-3 top-3 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-[11px] font-bold text-white">
                                {{ totalUnreadCount > 99 ? '99+' : totalUnreadCount }}
                            </span>
                        }
                    </div>

                    <div class="mx-4 flex-1">
                        <div class="relative w-full">
                            <mat-form-field class="w-full" appearance="fill" subscriptSizing="dynamic">
                                <mat-icon matPrefix class="text-secondary">search</mat-icon>
                                <input matInput
                                       [(ngModel)]="searchQuery"
                                       (input)="onSearchInput($event)"
                                       (focus)="onSearchFocus()"
                                       (blur)="onSearchBlur()"
                                       placeholder="Rechercher un utilisateur...">
                            </mat-form-field>

                            @if (showSearchResults && searchResults.length > 0) {
                                <div class="absolute left-0 right-0 z-50 mt-1 max-h-80 overflow-auto rounded-2xl border border-gray-200 bg-card py-2 shadow-2xl dark:border-gray-700">
                                    @for (user of searchResults; track user.id) {
                                        <div class="flex cursor-pointer items-center gap-3 px-4 py-3 hover:bg-gray-100 dark:hover:bg-hover"
                                             (click)="selectUserFromSearch(user); $event.stopImmediatePropagation()">
                                            <img [src]="user.avatar || 'images/avatars/male-01.jpg'" class="h-10 w-10 rounded-full object-cover" alt="">
                                            <div class="truncate font-medium">{{ user.fullName }}</div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>

                    <button class="mr-4" mat-icon-button (click)="toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                </div>
            }

            @if (opened && selectedChat) {
                <div class="ml-3 flex flex-auto items-center">
                    <div class="relative flex h-10 w-10 flex-0 items-center justify-center">
                        @if (chat) {
                            <img class="h-full w-full rounded-full object-cover" src="images/avatars/male-01.jpg" alt="Contact avatar" />
                        }
                        @if (!chat) {
                            <div class="flex h-full w-full items-center justify-center rounded-full bg-gray-200 text-lg uppercase text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                {{ getOtherUserFullName().charAt(0) }}
                            </div>
                        }
                    </div>
                    <div class="ml-4 truncate text-lg font-medium leading-5">
                        {{ getOtherUserFullName() }}
                    </div>
                    <button class="ml-2" mat-icon-button type="button" (click)="startAudioCall()" title="Appel audio">
                        <mat-icon [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                    </button>
                    <button class="ml-1" mat-icon-button type="button" (click)="startVideoCall()" title="Appel video">
                        <mat-icon [svgIcon]="'heroicons_outline:video-camera'"></mat-icon>
                    </button>
                    <button class="ml-auto mr-4" mat-icon-button (click)="toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                </div>
            }
        </div>

        <!-- Content -->
        <div class="flex flex-auto overflow-hidden border-t">
            <!-- Chat list -->
            <div class="quick-chat-rail h-full w-16 flex-0 overflow-y-auto overscroll-y-contain sm:overflow-hidden sm:overscroll-auto"
                 fuseScrollbar [fuseScrollbarOptions]="{ wheelPropagation: false }">
                <div class="flex-auto">
                    @for (conv of conversations; track trackConversationByFn($index, conv)) {
                        <div class="quick-chat-rail-item flex cursor-pointer items-center px-4 py-3 hover:bg-gray-100 dark:hover:bg-hover"
                             [ngClass]="{ 'bg-primary-50 dark:bg-hover': selectedChat?.id === conv.id }"
                             (click)="selectChat(conv)">
                            <div class="quick-chat-rail-avatar relative flex h-8 w-8 flex-0 items-center justify-center">
                                <img class="h-full w-full rounded-full object-cover" src="images/avatars/male-01.jpg" alt="avatar" />
                                @if (!chat) {
                                    <div class="flex h-full w-full items-center justify-center rounded-full bg-gray-200 text-lg uppercase text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                        {{ getOtherUserFullName().charAt(0) }}
                                    </div>
                                }
                                @if (isOnline(conv.user1 == currentUserId ? conv.user2 : conv.user1)) {
                                    <div class="absolute bottom-0 right-0 h-3 w-3 rounded-full border-2 border-white bg-green-500 dark:border-gray-800"></div>
                                }
                                @if (isConversationTyping(conv)) {
                                    <div class="quick-chat-typing-badge absolute -left-1 -top-1 flex h-4 w-6 items-center justify-center rounded-full bg-green-500">
                                        <span></span><span></span><span></span>
                                    </div>
                                }
                                @if (getConversationUnreadCount(conv) > 0) {
                                    <div class="absolute -right-2 -top-2 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-[11px] font-bold text-white shadow">
                                        {{ getConversationUnreadCount(conv) > 99 ? '99+' : getConversationUnreadCount(conv) }}
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>

            <!-- Conversation -->
            <div class="quick-chat-conversation flex flex-auto flex-col overflow-hidden border-l bg-gray-50 dark:bg-transparent">
                @if (chat && selectedChat) {
                    <div class="quick-chat-message-scroll flex flex-col-reverse flex-auto overflow-y-auto overscroll-y-contain" #messageContainer>
                        <div class="quick-chat-message-list flex flex-auto shrink flex-col">
                            @for (message of chat; track trackMessageByFn($index, message); let i = $index; let first = $first; let last = $last) {
                                @if (first || (chat[i - 1]?.sentAt | date:'d') !== (message.sentAt | date:'d')) {
                                    <div class="-mx-6 my-3 flex items-center justify-center">
                                        <div class="flex-auto border-b"></div>
                                        <div class="text-secondary mx-4 flex-0 text-sm font-medium leading-5">
                                            {{ message.sentAt | date:'longDate' }}
                                        </div>
                                        <div class="flex-auto border-b"></div>
                                    </div>
                                }

                                <div class="flex flex-col" [ngClass]="{
                                    'items-end': message.isMine,
                                    'items-start': !message.isMine,
                                    'mt-0.5': i > 0 && chat[i-1].isMine === message.isMine,
                                    'mt-3': i > 0 && chat[i-1].isMine !== message.isMine
                                }">
                                    <div class="quick-chat-message-bubble relative rounded-lg" [ngClass]="{
                                        'bg-blue-500 text-blue-50': message.isMine,
                                        'bg-gray-500 text-gray-50': !message.isMine
                                    }">
                                        @if (last || chat[i + 1]?.isMine !== message.isMine) {
                                            <div class="absolute bottom-0 w-3" [ngClass]="{
                                                '-right-1 -mr-px mb-px text-blue-500': message.isMine,
                                                '-left-1 -ml-px mb-px -scale-x-1 text-gray-500': !message.isMine
                                            }">
                                                <ng-container *ngTemplateOutlet="speechBubbleExtension"></ng-container>
                                            </div>
                                        }

                                        @if (message.content) {
                                            <div class="min-w-4 leading-5" [innerHTML]="message.content"></div>
                                        }

                                        @if (message.attachmentFileKey) {
                                            <button type="button"
                                                    class="quick-chat-attachment-card mt-2 flex items-center gap-2 rounded-lg border px-3 py-2 text-left"
                                               [ngClass]="{
                                                   'border-blue-200 bg-blue-50 text-blue-700': message.isMine,
                                                   'border-gray-300 bg-gray-100 text-gray-700': !message.isMine
                                               }"
                                               (click)="openAttachment(message.attachmentFileKey)">
                                                <mat-icon class="icon-size-5">attach_file</mat-icon>
                                                <div class="min-w-0 flex-1">
                                                    <div class="truncate text-sm font-medium">
                                                        {{ message.attachmentFileName || 'Piece jointe' }}
                                                    </div>
                                                    <div class="text-xs opacity-80">
                                                        Ouvrir le fichier
                                                    </div>
                                                </div>
                                            </button>
                                        }
                                    </div>

                                    @if (first || last || chat[i + 1]?.isMine !== message.isMine || chat[i + 1]?.sentAt !== message.sentAt) {
                                        <div class="text-secondary my-0.5 text-sm font-medium" [ngClass]="{'mr-3': message.isMine, 'ml-3': !message.isMine}">
                                            {{ message.sentAt | date:'HH:mm' }}
                                        </div>
                                    }
                                </div>
                            }

                            @if (isTyping && selectedChat) {
                                <div class="mt-3 flex items-start">
                                    <div class="typing-indicator">
                                        <div class="typing-dot"></div>
                                        <div class="typing-dot"></div>
                                        <div class="typing-dot"></div>
                                        <span class="ml-2 text-sm font-medium">
                                            {{ getTypingUserName() }} est en train d'ecrire...
                                        </span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <!-- Message input -->
                    <div class="quick-chat-composer relative flex items-end border-t bg-gray-50 dark:bg-transparent">
                        <input #attachmentInput type="file" hidden (change)="onAttachmentSelected($event)" />

                        @if (pendingAttachment) {
                            <div class="absolute bottom-16 left-4 right-4 z-10 rounded-lg border border-blue-200 bg-white px-3 py-2 shadow-sm">
                                <div class="flex items-center gap-2">
                                    <mat-icon class="icon-size-5 text-primary">attach_file</mat-icon>
                                    <div class="min-w-0 flex-1">
                                        <div class="truncate text-sm font-medium">
                                            {{ pendingAttachment.fileName }}
                                        </div>
                                        <div class="text-secondary text-xs">
                                            Fichier pret a etre envoye
                                        </div>
                                    </div>
                                    <button mat-icon-button type="button" (click)="removePendingAttachment()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            </div>
                        }

                        <mat-form-field class="fuse-mat-dense fuse-mat-rounded fuse-mat-bold min-w-0 flex-1" subscriptSizing="dynamic">
                            <textarea matInput cdkTextareaAutosize #messageInput
                                      (input)="onTyping()"
                                      (keydown.enter)="sendMessage(); $event.preventDefault()"
                                      placeholder="Ecrivez un message..."></textarea>
                        </mat-form-field>
                        <div class="my-px ml-2 flex h-11 flex-none items-center">
                            <button mat-icon-button type="button" (click)="openAttachmentPicker()" [disabled]="attachmentUploading" title="Ajouter une piece jointe">
                                <mat-icon>attach_file</mat-icon>
                            </button>
                        </div>
                        <div class="my-px ml-1 flex h-11 flex-none items-center">
                            <button mat-icon-button (click)="sendMessage()">
                                <mat-icon [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon>
                            </button>
                        </div>
                    </div>
                } @else {
                    <div class="flex h-full w-full flex-auto flex-col items-center justify-center p-4">
                        <mat-icon class="icon-size-24" [svgIcon]="'heroicons_outline:chat-bubble-bottom-center-text'"></mat-icon>
                        <div class="text-secondary mt-4 text-center text-xl font-medium tracking-tight">
                            Selectionnez une conversation
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>

    <quick-chat-call
        [session]="callSession"
        (close)="closeCallPopup()"
        (callFinished)="onCallFinished($event)"
    ></quick-chat-call>
</div>

<!-- Speech bubble SVG -->
<ng-template #speechBubbleExtension>
    <svg width="100%" height="100%" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M1.01522827,0.516204834 C-8.83532715,54.3062744 61.7609863,70.5215302 64.8009949,64.3061218 C68.8074951,54.8859711 30.1663208,52.9997559 37.5036011,0.516204834 L1.01522827,0.516204834 Z" fill="currentColor" fill-rule="nonzero"></path>
        </g>
    </svg>
</ng-template>
